import { LineItem } from 'shared/types/cart'
import { Attributes } from 'shared/types/product'

export const isLoyaltyProduct = (product: LineItem, locale: string): boolean => {
  if(product?.variant?.attributes && product?.totalPrice?.centAmount !== undefined){
    const loyaltyPointsPrice = getProductLoyaltyPoints(product?.variant?.attributes, locale)

    if(product?.totalPrice?.centAmount <= 0 && loyaltyPointsPrice > 0){
      return true
    }
  }

  return false
}

export const getProductLoyaltyPoints = (attributes: Attributes| undefined, locale: string): number=> {
  if(attributes === undefined){
    return 0
  }

  switch (locale){
    case 'de-DE':
      return attributes?.loyaltyPointsPriceDe ?? 0
    case 'de-AT':
      return attributes?.loyaltyPointsPriceAT ?? 0
    default:
      return 0
  }
}

export const getPetColorHashFromType = (type:string) => {
  switch (type) {
    case 'dog':
      return '#FA9600'
    case 'cat':
      return '#780144'
    case 'bird':
      return '#89B2A4'
    case 'small-animal':
      return '#035C58'
    case 'aqua':
      return '#51BBB1'
    case 'terra':
      return '#ad794D'
    default:
      return '#00869D'
  }
}

export const getPetColorFromType = (type: string | null, light:boolean = false) => {
  switch (type) {
    case 'dog':
      return `bg-animal-dog${light ? '-light' : ''}`
    case 'cat':
      return `bg-animal-cat${light ? '-light' : ''}`
    case 'bird':
      return `bg-animal-bird${light ? '-light' : ''}`
    case 'small-animal':
      return `bg-animal-small-animal${light ? '-light' : ''}`
    case 'aqua':
      return `bg-animal-aqua${light ? '-light' : ''}`
    case 'terra':
      return `bg-animal-terra${light ? '-light' : ''}`
    default:
      return 'bg-primary'
  }
}
